import { create } from 'zustand';

const emptyState = () => ({
  activeKey: null,
  type: null,
  producerIds: new Set(),
  consumerIds: new Set(),
  traceNodeIds: new Set(),
  traceEdgeIds: new Set(),
});

const usePlaceholderTraceStore = create((set, get) => ({
  ...emptyState(),

  setTrace: ({ activeKey, type, producerIds, consumerIds, traceNodeIds, traceEdgeIds }) =>
    set({ activeKey, type, producerIds, consumerIds, traceNodeIds, traceEdgeIds }),

  clear: () => set(emptyState()),

  toggleKey: (key, activate) => {
    if (!key) return;
    const current = get().activeKey;
    if (current === key) {
      get().clear();
      return;
    }
    if (typeof activate === 'function') activate(key);
  },
}));

export default usePlaceholderTraceStore;
